import styled from "@emotion/styled";
const Date = {
    Wrapper: styled.span `
    color: ${({ theme }) => theme.color.textMuted};
    font-size: 0.8rem;
    margin-left: 1em;
  `,
};
export default Date;
//# sourceMappingURL=MessageDate.styled.js.map